import React from 'react';
import Container from "@mui/material/Container";
import CustomMarkdown from "../components/customMarkdown/CustomMarkdown";

function TermsAndConditions() {
    return (
        <Container maxWidth="md" sx={{p:6}}>
            <CustomMarkdown children={['legal.terms']}/>
        </Container>
    );
}

export default TermsAndConditions;
